import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class PhotoService {

  private VISIOTEX_BASE_URL = environment.visiotexBaseURL;

  constructor(private httpClient: HttpClient) {
  }

  readImage(image) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.readAsDataURL(image);
    });
  }

  sendToWebExpert(body): Observable<any> {

    return this.httpClient.post<any>(this.VISIOTEX_BASE_URL + '/info/DossierService.svc/uploadImageHQ', body);
  }



}



// WEBPACK FOOTER //
// ./src/app/photo/photo.service.ts